import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap5';

export default function CoachItem({ coach, removeCoach }) {
  return (
    <div className="program-card position-relative mb-3">
      <div className="icon-with-text position-absolute top-0 start-0 mt-2 ms-2">
        <i className="small-icon user-icon" />
      </div>

      <Button
        variant="link"
        className="position-absolute top-0 end-0 mt-2 me-2 icon-with-text"
        onClick={() => removeCoach(coach)}
      >
        <i className="small-icon trash-icon" />
      </Button>

      <div className="ms-4 me-4">
        <div className="row mb-1">
          <div className="col-sm-4"><div className="fw-light">First Name</div></div>
          <div className="col-sm-8"><div className="fw-semibold text-truncate">{coach.firstName}</div></div>
        </div>

        <div className="row mb-1">
          <div className="col-sm-4"><div className="fw-light">Last Name</div></div>
          <div className="col-sm-8"><div className="fw-semibold text-truncate">{coach.lastName}</div></div>
        </div>

        <div className="row mb-1">
          <div className="col-sm-4"><div className="fw-light">Email</div></div>
          <div className="col-sm-8"><div className="fw-semibold text-truncate">{coach.email}</div></div>
        </div>

        {coach.error && (
          <div className="row mb-1">
            <div className="col-sm-4"><div className="fw-light">Error</div></div>
            <div className="col-sm-8"><div className="fw-semibold text-danger">{coach.error}</div></div>
          </div>
        )}
      </div>
    </div>
  );
}

CoachItem.propTypes = {
  coach: PropTypes.object.isRequired,
  removeCoach: PropTypes.func.isRequired,
};
